<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import MainTitleComponent from '@/components/ui/MainTitleComponent.vue';

const { t } = useI18n()
</script>

<template>
  <MainTitleComponent icon="PhProhibit">
    {{ t('views.unauthorized.title') }}
  </MainTitleComponent>

  <p>
    {{ t('views.unauthorized.content') }}
  </p>
</template>
